// src/app/pipes/translate.pipe.ts
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'translate',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private translationService = inject(TranslationService);

  transform(key: string): string {
    const parts = key.split('.');
    let value: any = this.translationService['translations']; // acceso directo al objeto

    for (const part of parts) {
      value = value?.[part];
      if (value === undefined) return key; // si en algún punto no encuentra, retorna la clave
    }

    return value;
  }
}
